import { Component } from '@angular/core';
import { HeaderComponent } from "../header/header.component";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-termscondition',
  standalone: true,
  imports: [HeaderComponent, CommonModule],
  templateUrl: './termscondition.component.html',
  styleUrl: './termscondition.component.css'
})
export class TermsconditionComponent {

}
